import React from "react"
import styled from "styled-components"
import { Label } from "buoy-core"
import CollapsibleFormCard from "../../../../account/components/CollapsibleFormCard"
import { FormRow, InputContainer } from "../../../../account/components/forms/common"
import { ToolTip } from "../../../../account/components/CardSubSection"
import FormField from "./FormField"

const RowLabelContainer = styled.div`
  display: flex;
`

const RowLabel = styled(Label)`
  margin: 0 6px 8px 0;
`

const Row = ({ last, label, tooltip, ...props }) => (
  <FormRow last={last}>
    <InputContainer>
      <RowLabelContainer>
        {label && <RowLabel>{label}</RowLabel>}
        {tooltip && <ToolTip message={tooltip} />}
      </RowLabelContainer>
      {props.children}
    </InputContainer>
  </FormRow>
)

const ProfileForm = ({
  config,
  office,
  planProvider,
  plan,
  holder,
  onOfficeResponse,
  onPlanProviderResponse,
  onPlanResponse,
  onHolderResponse,

  // only used in profile:
  edit,
  save,
  cancel,
  disabled,
  isEditing,
  getResponseText,
  isPublic,
}) => (
  <CollapsibleFormCard
    name="Insurance Information"
    dirty={isEditing}
    edit={edit}
    save={save}
    cancel={cancel}
    disabled={disabled}
  >
    {!isPublic && (
      <Row
        label={config.fields.office.label}
        tooltip={isEditing ? config.fields.office.tooltip : null}
      >
        <FormField
          disabled={true}
          text={getResponseText(office.options, office.selected)}
          placeholder={config.fields.office.placeholder}
          options={office.options}
          value={office.selected}
          onChange={onOfficeResponse}
          isEditing={isEditing}
          disableDropdown
        />
      </Row>
    )}

    <Row
      last={holder === "NA" || isPublic} // remove when Plan field (below) is used
      label={config.fields.planProvider.label}
    >
      <FormField
        disabled={planProvider.options.length === 0}
        text={getResponseText(planProvider.options, planProvider.selected)}
        placeholder={config.fields.planProvider.placeholder}
        options={planProvider.options}
        value={planProvider.selected}
        onChange={onPlanProviderResponse}
        isEditing={isEditing}
      />
    </Row>
{/* 
    <Row
      last={holder === "NA"}
      label={config.fields.plan.label}
    >
      <FormField
        disabled={plan.options.length === 0}
        text={getResponseText(plan.options, plan.selected)}
        placeholder={config.fields.plan.placeholder}
        options={plan.options}
        value={plan.selected}
        onChange={onPlanResponse}
        isEditing={isEditing}
      />
    </Row> */}

    {holder !== "NA" && !isPublic && (
      <Row
        label={config.fields.holder.label}
        last
      >
        <FormField
          disabled={!plan.selected}
          text={getResponseText(config.fields.holder.options, holder)}
          placeholder={config.fields.holder.placeholder}
          options={config.fields.holder.options}
          value={holder}
          onChange={onHolderResponse}
          isEditing={isEditing}
        />
      </Row>
    )}
  </CollapsibleFormCard>
)

export { ProfileForm as default }


// WEBPACK FOOTER //
// ./assets/common/components/PlanDetails/components/ProfileForm.js